import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function ObjectionsSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: 'My child is extremely sensitive. Will this work?',
    a: 'Yes. We don\'t use force. We use "Micro-Shifts" so small the sensory system doesn\'t even trigger a "danger" signal.'
  }, {
    q: "I don't have time to cook complicated meals.",
    a: 'None of us do. This method works with your existing Safe Foods and store-bought items. No "chef skills" required.'
  }, {
    q: 'Is this just for toddlers?',
    a: "No. Sensory issues don't have an age limit. This works for children from 2 to 15 years old."
  }, {
    q: "What if it doesn't work for us?",
    a: 'You are protected by our 30-Day "One-New-Food" Guarantee. If your child doesn\'t try at least one new food, you get a full refund. No questions asked.'
  }];
  const toggle = (i: number) => setOpenIndex(openIndex === i ? null : i);
  return <section className="py-12 md:py-20 px-4 md:px-6 bg-[var(--bg-deep)]" data-id="element-180">
      <div className="max-w-[680px] mx-auto" data-id="element-181">
        <h2 className="text-2xl md:text-4xl font-serif text-center mb-8 md:mb-12 text-[var(--text-heading)]" data-id="element-182">
          Frequently Asked Questions
        </h2>

        <div className="space-y-3 md:space-y-4" data-id="element-183">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-[var(--bg-card)] rounded-xl border border-[var(--border-subtle)] shadow-sm overflow-hidden" data-id="element-184">
              <button onClick={() => toggle(i)} className="w-full flex items-center justify-between gap-4 p-5 md:p-6 text-left" data-id="element-185">
                <span className="font-bold text-[var(--text-heading)] text-base md:text-lg pr-4" data-id="element-186">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === i ? 180 : 0
            }} transition={{
              duration: 0.2
            }} className="flex-shrink-0 text-[var(--accent)] bg-[var(--accent-soft)] p-1.5 rounded-full" data-id="element-187">
                  <ChevronDown className="w-5 h-5" data-id="element-188" />
                </motion.div>
              </button>

              <AnimatePresence initial={false} data-id="element-189">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-190">
                    <p className="px-5 md:px-6 pb-5 md:pb-6 text-[var(--text-primary)] text-sm md:text-base leading-relaxed border-t border-[var(--border-subtle)] pt-4" data-id="element-191">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}